import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";

interface LottiePlayerProps {
  src: string | Record<string, unknown>;
}

const LottiePlayer: React.FC<LottiePlayerProps> = ({ src }) => {
  return (
    <Player
      autoplay={true}
      loop={true}
      controls={false}
      src={src}
      style={{ height: "100%" }}
    />
  );
};

export default LottiePlayer;
